/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//German (Germany)
export default {
  'feedback-collector.anonymous': 'Dieses Feedback wird anonym übermittelt. Atlassian wird Sie bezüglich dieses Feedbacks nicht direkt kontaktieren können.',
  'feedback-collector.anonymous.title': 'Anonymes Feedback',
  'feedback-collector.can-be-contacted.label': 'Ja, Atlassian-Teams dürfen mich kontaktieren, um weitere Informationen zu meinen Erfahrungen zu erhalten, damit Produkte und Services von Atlassian verbessert werden können. Ich erkläre mich mit der <a>Datenschutzrichtlinie von Atlassian</a> einverstanden.',
  'feedback-collector.cancel-button.label': 'Abbrechen',
  'feedback-collector.default.custom.textarea.label': 'Teilen Sie uns Ihre Meinung mit.',
  'feedback-collector.enrol-in-research.label': 'Ich würde gerne an der Produktforschung teilnehmen.',
  'feedback-collector.feedback-title': 'Teilen Sie uns Ihre Meinung mit',
  'feedback-collector.form.bug.label': 'Beschreiben Sie den Bug oder den Vorgang.',
  'feedback-collector.form.comment.label': 'Teilen Sie uns Ihre Meinung mit.',
  'feedback-collector.form.empty.label': 'Wählen Sie eine Option aus.',
  'feedback-collector.form.question.label': 'Was möchten Sie wissen?',
  'feedback-collector.form.suggestion.label': 'Teilen Sie uns mit, was Ihrer Meinung nach verbessert werden sollte.',
  'feedback-collector.option.bug.label': 'Einen Bug melden',
  'feedback-collector.option.comment.label': 'Einen Kommentar hinterlassen',
  'feedback-collector.option.default.label': 'Feedback auswählen',
  'feedback-collector.option.default.placeholder': 'Wählen Sie eine Option aus',
  'feedback-collector.option.question.label': 'Eine Frage stellen',
  'feedback-collector.option.suggestion.label': 'Einen Verbesserungsvorschlag machen',
  'feedback-collector.required.fields.summary': 'Pflichtfelder sind mit einem Sternchen markiert.',
  'feedback-collector.submit-button.label': 'Feedback senden',
  'feedback-collector.success-flag.description': 'Ihr Feedback hilft uns dabei, unsere Produkte ständig zu verbessern.',
  'feedback-collector.success-flag.title': 'Vielen Dank!',
  'feedback-collector.summary-placeholder': 'Teilen Sie uns Ihre Meinung mit.',
  'proforma-form-builder.feedback-icon-label': 'Feedback',
  'proforma-form-builder.give-feedback': 'Feedback geben'
};